import { Injectable } from '@angular/core';

import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { LightsSettingsSupportType } from '@shure/shared/angular/features/device-lights-settings/data-access';
import {
	LightsImage,
	LightsImageProvider
} from '@shure/shared/angular/features/device-lights-settings/feature-device-image-next';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

@Injectable()
export class Mxa925CdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin implements LightsImageProvider {
	public override readonly models: DeviceModel[] = [DeviceModel.MXA925R, DeviceModel.MXA925S];

	public override getLightsSettingsSupportType(): LightsSettingsSupportType {
		return LightsSettingsSupportType.Supported;
	}

	public getLightsImage(model: DeviceModel): LightsImage {
		return {
			imageUrl: `device-mxa9xx-${model === DeviceModel.MXA925S ? 's' : 'r-rotated'}.svg`
		};
	}
}
